import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import api from "../services/api";

// Capa: fica em public/images/CapaLogin2.webp — referenciada via process.env.PUBLIC_URL
// no styles.brand (não precisa de import).

const DARK_NAV = "#1c2025";
const SENHA_PADRAO = "123456";

export default function Login() {
  const [login, setLogin]         = useState("");
  const [senha, setSenha]         = useState("");
  const [showSenha, setShowSenha] = useState(false);
  const [loading, setLoading]     = useState(false);
  const navigate = useNavigate();

  const [pendingUser, setPendingUser]   = useState(null);
  const [showConfirmTroca, setShowConfirmTroca] = useState(false);
  const [showFormTroca, setShowFormTroca]       = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!login || !senha) {
      toast.error("Preencha login e senha");
      return;
    }

    setLoading(true);

    try {
      const response = await api.get("/ServerPrincipal/PesqLogin", {
        params: { login, senha },
      });

      let userData = null;

      if (
        response.data?.FDBS?.Manager?.TableList?.length > 0 &&
        response.data.FDBS.Manager.TableList[0].RowList?.length > 0
      ) {
        userData = response.data.FDBS.Manager.TableList[0].RowList[0].Original;
      }

      if (userData) {
        const userAtivo = userData.log_ativo;

        if (userAtivo === 0) {
          toast.error("Usuário inativo. Contate o administrador.");
          return;
        }

        if (senha === SENHA_PADRAO) {
          setPendingUser(userData);
          setShowConfirmTroca(true);
          return;
        }

        finalizarLogin(userData);
      } else {
        toast.error("Login ou senha inválidos");
      }
    } catch (error) {
      console.error("Erro no login:", error);
      toast.error("Erro ao fazer login. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  const finalizarLogin = (userData) => {
    const userId    = userData.log_id;
    const userLogin = userData.log_login;
    const userEmail = userData.log_email;
    const userCliente = userData.log_cliente;
    const userIdCliente = userData.cli_id;

    localStorage.setItem("userID",    userId.toString());
    localStorage.setItem("userName",  userLogin);
    localStorage.setItem("userEmail", userEmail || "");
    localStorage.setItem("userLogin", login);
    localStorage.setItem("userCliente", userCliente?.toString() || "0");
    localStorage.setItem("userIdCliente", userIdCliente.toString());

    if (userCliente === 1) {
      toast.success(`Bem-vindo, ${userLogin}!`);
      navigate("/dashboard", { state: { currentPage: "carteira" } });
    } else {
      toast.success(`Bem-vindo, ${userLogin}!`);
      navigate("/dashboard");
    }
  };

  const handleForgot = () => {
    toast("Contate o administrador para redefinir sua senha.");
  };

  return (
    <div style={styles.container} className="gvs-login">
      <style>{`
        /* ⬇️ NOVO: fontes que combinam com a logo (serifada dourada).
           Ideal seria colocar este <link> no public/index.html para performance,
           mas via @import também funciona. */
        @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@500;600;700&family=Cormorant+Garamond:ital,wght@0,500;0,600;1,500;1,600&display=swap');

        .gvs-login .gvs-input:focus {
          border-color: #2F6DF6;
          box-shadow: 0 0 0 3px rgba(47,109,246,0.15);
        }
        .gvs-login .gvs-input::placeholder { color: #B4B4BC; }
        .gvs-login .gvs-eye:hover { color: #2F6DF6; }
        .gvs-login .gvs-link:hover { text-decoration: underline; }
        .gvs-login .gvs-btn:hover:not(:disabled) { background: #1c1c24; box-shadow: 0 6px 20px rgba(0,0,0,0.25); }
        .gvs-login .gvs-btn:active:not(:disabled) { transform: translateY(1px); }
        
        @media (max-width: 860px) {
          .gvs-login .gvs-card { 
            flex-direction: column; 
            border-radius: 0;
          }
          .gvs-login .gvs-brand {
            flex: none;
            padding: 30px 24px 20px;
            justify-content: flex-start;
            gap: 16px;
            min-height: 180px;
          }
          .gvs-login .gvs-brandText,
          .gvs-login .gvs-features { display: none; }
          .gvs-login .gvs-brandMid { max-width: none; }
          .gvs-login .gvs-brandHeading { font-size: 26px; }
          .gvs-login .gvs-formSide {
            flex: 1;
            border-radius: 24px 24px 0 0;
            padding: 28px 20px 32px;
            margin-top: -20px;
            position: relative;
          }
          .gvs-login .gvs-brandArt { display: none; }
        }
        
        @media (max-width: 480px) {
          .gvs-login .gvs-brand { 
            padding: 20px 16px 16px; 
            min-height: 140px;
          }
          .gvs-login .gvs-brandHeading { font-size: 22px; }
          .gvs-login .gvs-formSide { 
            padding: 20px 16px 28px; 
            border-radius: 20px 20px 0 0;
          }
          .gvs-login .gvs-title { font-size: 20px; }
          .gvs-login .gvs-subtitle { font-size: 12px; }
          .gvs-login .gvs-input { 
            font-size: 13px; 
            padding: 10px 14px;
            padding-left: 38px;
          }
          .gvs-login .gvs-btn { font-size: 13px; padding: 12px; }
          .gvs-login .gvs-logo { font-size: 28px; }
          .gvs-login .gvs-logoSub { font-size: 11px; }
        }
        
        @media (max-width: 380px) {
          .gvs-login .gvs-brand { 
            padding: 16px 12px 12px; 
            min-height: 120px;
          }
          .gvs-login .gvs-brandHeading { font-size: 19px; }
          .gvs-login .gvs-formSide { 
            padding: 16px 12px 24px; 
          }
          .gvs-login .gvs-title { font-size: 18px; }
          .gvs-login .gvs-input { 
            font-size: 12px; 
            padding: 8px 12px;
            padding-left: 34px;
          }
          .gvs-login .gvs-leftIcon { left: 10px; }
          .gvs-login .gvs-leftIcon svg { width: 15px; height: 15px; }
        }
      `}</style>

      <div style={styles.card} className="gvs-card">

        <div style={styles.brand} className="gvs-brand">
          {/* Arte SVG desativada: a capa (CapaLogin2.webp) agora é o fundo.
              Para reativá-la, mude brandArtHidden lá embaixo para {} */}
          <svg style={{ ...styles.brandArt, ...styles.brandArtHidden }} className="gvs-brandArt" viewBox="0 0 400 640"
               preserveAspectRatio="xMidYMid slice" aria-hidden="true">
            <path d="M300 -40 C 388 150, 250 290, 356 450 S 262 620, 408 720"
                  fill="none" stroke="#2F6DF6" strokeWidth="1.4" opacity="0.45" />
            <path d="M348 -40 C 436 170, 292 310, 398 470 S 304 640, 450 740"
                  fill="none" stroke="#2F6DF6" strokeWidth="1" opacity="0.2" />
            <g stroke="#3A5BD0" strokeWidth="0.6" opacity="0.16">
              <path d="M400 420 L 205 640" />
              <path d="M400 460 L 255 640" />
              <path d="M400 500 L 305 640" />
            </g>
          </svg>

          <div style={styles.brandTop}>
            <div style={styles.logoRow}>
              <div style={styles.logo} className="gvs-logo">
                GVS Vip
              </div>
              <div style={styles.logoLine} aria-hidden="true" />
              <div style={styles.logoSub} className="gvs-logoSub">Guilherme Vieira Santos</div>
            </div>
          </div>

          <div style={styles.brandMid} className="gvs-brandMid">
            <h1 style={styles.brandHeading} className="gvs-brandHeading">
              Gestão que<br />
              impulsiona <span style={styles.accent}>resultados.</span>
            </h1>
            <p style={styles.brandText} className="gvs-brandText">
              Centralize, gerencie e potencialize cada milha do seu patrimônio.
            </p>
          </div>

          <div style={styles.features} className="gvs-features">
            <Feature icon={<ChartIcon />} label="Performance" />
            <Feature icon={<ShieldIcon />} label="Segurança" />
            <Feature icon={<UsersIcon />} label="Confiabilidade" />
          </div>
        </div>

        <div style={styles.formSide} className="gvs-formSide">
          <div style={styles.formInner}>
            <div style={styles.header}>
              <h2 style={styles.title} className="gvs-title">Bem-vindo de volta</h2>
              <p style={styles.subtitle} className="gvs-subtitle">Acesse sua conta para continuar</p>
            </div>

            <form onSubmit={handleLogin} style={styles.form}>
              <div style={styles.fieldWrap}>
                <label style={styles.label} htmlFor="gvs-login">Login</label>
                <div style={styles.inputWrap}>
                  <span style={styles.leftIcon} className="gvs-leftIcon"><UserIcon /></span>
                  <input
                    id="gvs-login"
                    className="gvs-input"
                    style={{ ...styles.input, paddingLeft: 42 }}
                    type="text"
                    placeholder="Seu usuário"
                    value={login}
                    onChange={(e) => setLogin(e.target.value)}
                    disabled={loading}
                    autoComplete="username"
                  />
                </div>
              </div>

              <div style={styles.fieldWrap}>
                <label style={styles.label} htmlFor="gvs-senha">Senha</label>
                <div style={styles.inputWrap}>
                  <span style={styles.leftIcon} className="gvs-leftIcon"><LockIcon /></span>
                  <input
                    id="gvs-senha"
                    className="gvs-input"
                    style={{ ...styles.input, paddingLeft: 42, paddingRight: 44 }}
                    type={showSenha ? "text" : "password"}
                    placeholder="Digite sua senha"
                    value={senha}
                    onChange={(e) => setSenha(e.target.value)}
                    disabled={loading}
                    autoComplete="current-password"
                  />
                  <button
                    type="button"
                    className="gvs-eye"
                    style={styles.eyeBtn}
                    onClick={() => setShowSenha((v) => !v)}
                    disabled={loading}
                    aria-label={showSenha ? "Ocultar senha" : "Mostrar senha"}
                    title={showSenha ? "Ocultar senha" : "Mostrar senha"}
                  >
                    {showSenha ? <EyeOffIcon /> : <EyeIcon />}
                  </button>
                </div>
              </div>

              <div style={styles.forgotRow}>
                <button
                  type="button"
                  className="gvs-link"
                  style={styles.link}
                  onClick={handleForgot}
                >
                  Esqueci minha senha
                </button>
              </div>

              <button
                className="gvs-btn"
                style={{ ...styles.button, opacity: loading ? 0.7 : 1 }}
                type="submit"
                disabled={loading}
              >
                {loading ? "Entrando..." : "Entrar"}
              </button>
            </form>
          </div>
        </div>

      </div>

      {showConfirmTroca && (
        <ModalConfirmarTroca
          onRecusar={() => {
            setShowConfirmTroca(false);
            finalizarLogin(pendingUser);
          }}
          onAceitar={() => {
            setShowConfirmTroca(false);
            setShowFormTroca(true);
          }}
        />
      )}

      {showFormTroca && (
        <ModalTrocarSenha
          userId={pendingUser?.log_id}
          onVoltar={() => {
            setShowFormTroca(false);
            setShowConfirmTroca(true);
          }}
          onSucesso={() => {
            setShowFormTroca(false);
            finalizarLogin(pendingUser);
          }}
        />
      )}
    </div>
  );
}

function ModalConfirmarTroca({ onRecusar, onAceitar }) {
  return (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.box}>
        <div style={modalStyles.header}>
          <span style={modalStyles.headerTitle}>Senha padrão detectada</span>
        </div>
        <div style={modalStyles.body}>
          <p style={modalStyles.text}>
            Você está acessando com a senha padrão do sistema (<strong>123456</strong>).
            Por segurança, recomendamos que você defina uma senha própria agora.
          </p>
          <p style={{ ...modalStyles.text, marginTop: 8 }}>
            Deseja trocar sua senha agora?
          </p>
        </div>
        <div style={modalStyles.footer}>
          <button style={modalStyles.btnGhost} onClick={onRecusar}>
            Agora não
          </button>
          <button style={modalStyles.btnPrimary} onClick={onAceitar}>
            Trocar senha
          </button>
        </div>
      </div>
    </div>
  );
}

function ModalTrocarSenha({ userId, onVoltar, onSucesso }) {
  const [novaSenha, setNovaSenha]         = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const [showSenha1, setShowSenha1]       = useState(false);
  const [showSenha2, setShowSenha2]       = useState(false);
  const [loading, setLoading]             = useState(false);
  const [erro, setErro]                   = useState("");

  const validar = () => {
    if (!novaSenha || !confirmarSenha) return "Preencha os dois campos.";
    if (novaSenha.length < 6) return "A senha deve ter pelo menos 6 caracteres.";
    if (novaSenha === SENHA_PADRAO) return "Escolha uma senha diferente da padrão (123456).";
    if (novaSenha !== confirmarSenha) return "As senhas não conferem.";
    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const msg = validar();
    if (msg) { setErro(msg); return; }
    setErro("");
    setLoading(true);
    try {
      await api.post("/ServerPrincipal/AtualizarSenha", {
        Senha:   novaSenha,
        IDLogin: Number(userId),
      });
      toast.success("Senha atualizada com sucesso!");
      onSucesso();
    } catch (err) {
      console.error("Erro ao atualizar senha:", err);
      toast.error("Não foi possível atualizar a senha. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = { 
    width: "100%", 
    boxSizing: "border-box", 
    padding: "10px 40px 10px 12px", 
    border: "1px solid #d9d9d9", 
    borderRadius: 8, 
    fontSize: 14, 
    outline: "none", 
    color: "#333",
    WebkitAppearance: "none",
  };
  
  const labelStyle = { 
    fontSize: 12.5, 
    fontWeight: 600, 
    color: "#3A3A44", 
    marginBottom: 6, 
    display: "block" 
  };

  return (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.box}>
        <div style={modalStyles.header}>
          <span style={modalStyles.headerTitle}>Definir nova senha</span>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{ ...modalStyles.body, display: "flex", flexDirection: "column", gap: 14 }}>
            <div>
              <label style={labelStyle}>Nova senha</label>
              <div style={{ position: "relative" }}>
                <input
                  type={showSenha1 ? "text" : "password"}
                  style={inputStyle}
                  placeholder="Mínimo 6 caracteres"
                  value={novaSenha}
                  onChange={(e) => { setNovaSenha(e.target.value); setErro(""); }}
                  disabled={loading}
                  autoFocus
                />
                <span onClick={() => setShowSenha1(v => !v)} style={modalStyles.eyeToggle}>
                  {showSenha1 ? <EyeOffIcon /> : <EyeIcon />}
                </span>
              </div>
            </div>
            <div>
              <label style={labelStyle}>Confirmar nova senha</label>
              <div style={{ position: "relative" }}>
                <input
                  type={showSenha2 ? "text" : "password"}
                  style={inputStyle}
                  placeholder="Repita a nova senha"
                  value={confirmarSenha}
                  onChange={(e) => { setConfirmarSenha(e.target.value); setErro(""); }}
                  disabled={loading}
                />
                <span onClick={() => setShowSenha2(v => !v)} style={modalStyles.eyeToggle}>
                  {showSenha2 ? <EyeOffIcon /> : <EyeIcon />}
                </span>
              </div>
            </div>
            {erro && <div style={{ color: "#ff4d4f", fontSize: 12.5 }}>{erro}</div>}
          </div>
          <div style={modalStyles.footer}>
            <button type="button" style={modalStyles.btnGhost} onClick={onVoltar} disabled={loading}>
              Voltar
            </button>
            <button type="submit" style={{ ...modalStyles.btnPrimary, opacity: loading ? 0.7 : 1 }} disabled={loading}>
              {loading ? "Salvando..." : "Salvar nova senha"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function Feature({ icon, label }) {
  return (
    <div style={styles.feature}>
      <span style={styles.featureIcon}>{icon}</span>
      <span style={styles.featureLabel}>{label}</span>
    </div>
  );
}

/* Ícones SVG inline */
const ico = {
  width: 20, height: 20, viewBox: "0 0 24 24", fill: "none",
  stroke: "currentColor", strokeWidth: 1.8,
  strokeLinecap: "round", strokeLinejoin: "round",
};
const UserIcon = () => (
  <svg {...ico} width="18" height="18">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);
const LockIcon = () => (
  <svg {...ico} width="18" height="18">
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);
const EyeIcon = () => (
  <svg {...ico} width="19" height="19">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);
const EyeOffIcon = () => (
  <svg {...ico} width="19" height="19">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);
const ChartIcon = () => (
  <svg {...ico}><path d="M3 3v18h18" /><path d="M7 15l3-4 4 3 5-7" /></svg>
);
const ShieldIcon = () => (
  <svg {...ico}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><path d="M9 12l2 2 4-4" /></svg>
);
const UsersIcon = () => (
  <svg {...ico}>
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    background: "#000",
    fontFamily: "inherit",
    overflow: "hidden",
  },
  card: {
    display: "flex",
    flex: 1,
    background: "linear-gradient(150deg, #15151f 0%, #0a0a0f 55%, #000 100%)",
    minHeight: "100vh",
    width: "100%",
  },
  brand: {
    position: "relative",
    flex: "1 1 46%",
    overflow: "hidden",
    color: "#fff",
    padding: "56px 60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    backgroundImage: `linear-gradient(100deg, rgba(9,11,15,0.94) 0%, rgba(9,11,15,0.78) 30%, rgba(9,11,15,0.42) 58%, rgba(9,11,15,0.14) 100%), linear-gradient(0deg, rgba(0,0,0,0.60) 0%, rgba(0,0,0,0) 42%), url(${process.env.PUBLIC_URL}/images/CapaLogin3.jpg)`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    boxShadow: "inset 0 0 140px 40px rgba(0,0,0,0.45)", // vinheta sutil
  },
  brandArt: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    pointerEvents: "none",
  },
  brandArtHidden: { display: "none" }, // ⬅️ NOVO: esconde a arte SVG antiga
  brandTop: { position: "relative" },
  logoRow: {},
  logo: {
    // Serifada (Cinzel) em BRANCO — o dourado vira acento fino, não a cor do texto
    fontFamily: "'Cinzel', serif",
    fontSize: 32,
    fontWeight: 600,
    letterSpacing: "3px",
    lineHeight: 1,
    color: "#FFFFFF",
    textShadow: "0 2px 18px rgba(0,0,0,0.45)",
  },
  logoLine: {
    // Hairline dourado: único toque de ouro, ecoa o traço da logo original
    width: 54,
    height: 2,
    borderRadius: 2,
    background: "linear-gradient(90deg, #C9A24B 0%, #F3DC94 100%)",
    margin: "13px 0 9px",
    boxShadow: "0 0 10px rgba(224,196,120,0.35)",
  },
  logoSub: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: "0.20em",
    color: "rgba(255,255,255,0.82)",
  },
  brandMid: { position: "relative", maxWidth: 360 },
  brandHeading: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: 44,
    fontWeight: 600,
    lineHeight: 1.12,
    letterSpacing: "-0.2px",
    margin: 0,
    color: "#FFFFFF",
    textShadow: "0 2px 20px rgba(0,0,0,0.40)",
  },
  // Destaque pelo ESTILO (itálico), não pela cor — texto continua branco
  accent: { fontStyle: "italic", fontWeight: 600, color: "#FFFFFF" },
  brandText: {
    fontSize: 14.5,
    lineHeight: 1.65,
    color: "rgba(255,255,255,0.78)",
    margin: "18px 0 0",
    maxWidth: 310,
  },
  // Cartão de vidro (glassmorphism): transparência + blur sobre a foto
  features: {
    position: "relative",
    display: "inline-flex",
    alignSelf: "flex-start",
    gap: 26,
    flexWrap: "wrap",
    alignItems: "center",
    background: "rgba(255,255,255,0.07)",
    border: "1px solid rgba(255,255,255,0.14)",
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    borderRadius: 16,
    padding: "16px 24px",
    boxShadow: "0 8px 30px rgba(0,0,0,0.25)",
  },
  feature: { display: "flex", flexDirection: "column", gap: 8 },
  featureIcon: { color: "#E0C57C", display: "flex" },
  featureLabel: {
    fontSize: 12.5,
    fontWeight: 500,
    letterSpacing: "0.02em",
    color: "rgba(255,255,255,0.88)",
  },

  formSide: {
    flex: "1 1 54%",
    background: "#fff",
    borderRadius: "40px 0 0 40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "48px 40px",
    minHeight: "100vh",
  },
  formInner: { width: "100%", maxWidth: 360 },
  header: { textAlign: "center", marginBottom: 30 },
  title: {
    fontSize: 26,
    fontWeight: 700,
    color: "#15151F",
    letterSpacing: "-0.4px",
    margin: 0,
  },
  subtitle: {
    fontSize: 14,
    color: "#8A8A94",
    margin: "8px 0 0",
    fontWeight: 400,
  },
  form: { display: "flex", flexDirection: "column", gap: 16 },
  fieldWrap: { display: "flex", flexDirection: "column", gap: 7 },
  label: {
    fontSize: 12.5,
    fontWeight: 600,
    color: "#3A3A44",
    letterSpacing: "0.2px",
  },
  inputWrap: { position: "relative", display: "flex", alignItems: "center" },
  leftIcon: {
    position: "absolute",
    left: 13,
    color: "#9AA0AC",
    display: "flex",
    pointerEvents: "none",
    zIndex: 1,
  },
  input: {
    width: "100%",
    boxSizing: "border-box",
    padding: "12px 14px",
    border: "1px solid #E6E6EA",
    borderRadius: 10,
    fontSize: 14,
    color: "#15151F",
    outline: "none",
    background: "#fff",
    transition: "border-color 0.15s, box-shadow 0.15s",
    fontFamily: "inherit",
    WebkitAppearance: "none",
  },
  eyeBtn: {
    position: "absolute",
    right: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 32,
    height: 32,
    padding: 0,
    border: "none",
    borderRadius: 7,
    background: "transparent",
    color: "#9AA0AC",
    cursor: "pointer",
    transition: "color 0.15s",
    zIndex: 1,
  },
  forgotRow: { display: "flex", justifyContent: "flex-end", marginTop: -4 },
  link: {
    background: "none",
    border: "none",
    padding: 0,
    fontSize: 13,
    color: "#2F6DF6",
    cursor: "pointer",
    fontFamily: "inherit",
    fontWeight: 500,
  },
  button: {
    marginTop: 6,
    padding: "13px",
    background: "#000000",
    color: "#fff",
    border: "none",
    borderRadius: 10,
    fontSize: 14.5,
    fontWeight: 600,
    cursor: "pointer",
    letterSpacing: "0.02em",
    transition: "background 0.15s, transform 0.05s",
    fontFamily: "inherit",
  },
};

const modalStyles = {
  overlay: {
    position: "fixed", inset: 0, zIndex: 2000,
    background: "rgba(0,0,0,0.5)",
    display: "flex", alignItems: "center", justifyContent: "center",
    padding: 16,
  },
  box: {
    background: "#fff", borderRadius: 12, width: 420, maxWidth: "95vw",
    boxShadow: "0 8px 40px rgba(0,0,0,0.25)", overflow: "hidden",
  },
  header: {
    background: DARK_NAV, padding: "16px 22px",
  },
  headerTitle: { fontSize: 15.5, fontWeight: 700, color: "#fff" },
  body: { padding: "20px 22px" },
  text: { fontSize: 14, color: "#444", lineHeight: 1.6, margin: 0 },
  footer: {
    padding: "14px 22px", borderTop: "1px solid #f0f0f0",
    display: "flex", justifyContent: "flex-end", gap: 10,
    flexWrap: "wrap",
  },
  btnGhost: {
    padding: "9px 18px", background: "#fff", border: "1px solid #d9d9d9",
    borderRadius: 8, cursor: "pointer", fontSize: 13.5, color: "#555", fontWeight: 500,
    minWidth: 80,
  },
  btnPrimary: {
    padding: "9px 20px", background: DARK_NAV, color: "#fff", border: "none",
    borderRadius: 8, cursor: "pointer", fontSize: 13.5, fontWeight: 600,
    minWidth: 80,
  },
  eyeToggle: {
    position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)",
    cursor: "pointer", color: "#9AA0AC", fontSize: 16, display: "flex",
  },
};